import React, { useEffect, useState } from "react";
import axios from "axios";
import progressGif from "../../images/progress.gif";
import { exportStyledExcel } from "./exportStyledExcel";

const Non_Avail_Cards_Excel = ({ startMonth, startYear, endMonth, endYear }) => {
  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [afsos, setAfsos] = useState([]);
  const [selectedAfso, setSelectedAfso] = useState("");
  const [loadingAfso, setLoadingAfso] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [reportData, setReportData] = useState([]);

  useEffect(() => {
    const fetchDistricts = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_URL}/api/nonAvailCards/districts`,
          { withCredentials: true }
        );
        const sorted = res.data.sort((a, b) =>
          a.distNameEn.localeCompare(b.distNameEn)
        );
        setDistricts(sorted);
      } catch (err) {
        console.error("Error fetching districts:", err);
      }
    };
    fetchDistricts();
  }, []);

  useEffect(() => {
  if (!selectedDistrict) {
    setAfsos([]);
    setSelectedAfso("");
    return;
  }

  if (selectedDistrict === "ALL") {
  setAfsos([{ afsoCode: "ALL", afsoName: "All AFSOs" }]);
  setSelectedAfso(""); 
  return;
}


  const fetchAfsos = async () => {
    setLoadingAfso(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL}/api/nonAvailCards/afsoList`,
        {
          params: { distCode: selectedDistrict },
          withCredentials: true,
        }
      );
      setAfsos(res.data || []);
      setSelectedAfso(""); 
    } catch (err) {
      console.error("Error fetching AFSOs:", err);
    } finally {
      setLoadingAfso(false);
    }
  };

  fetchAfsos();
}, [selectedDistrict]);

  const handleGetLink = async () => {
    setMessage("");
    setReportData([]);
    setLoading(true);

    if (!selectedDistrict) {
      alert("Please select a District");
      setLoading(false);
      return;
    }

    if (!selectedAfso) {
      alert("Please select an AFSO");
      setLoading(false);
      return;
    }

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL}/api/nonAvailCards/finalReport`,
        {
          params: {
            distCode: selectedDistrict || "ALL",
            officeCode: selectedAfso || "ALL",
          },
          withCredentials: true,
        }
      );

      if (res.data.length === 0) {
        setMessage("No data found for the selected filters.");
      } else {
        setReportData(res.data);

        const distName =
          selectedDistrict === "ALL"
            ? "All Districts"
            : districts.find((d) => d.distCode === selectedDistrict)?.distNameEn || selectedDistrict;

        let afsoName = "";
        if (selectedAfso === "ALL") {
          afsoName = "All AFSOs";
        } else {
          const afsoObj = afsos.find((a) => a.afsoCode === selectedAfso);
          afsoName = afsoObj ? afsoObj.afsoName : selectedAfso;
        }

        setMessage(
          `Excel download for Non Availed Cards from ${getMonthName(
            startMonth
          )}, ${startYear} to ${getMonthName(endMonth)}, ${endYear} in ${distName}, ${afsoName}`
        );
      }
    } catch (err) {
      console.error("Error fetching data:", err);
      setMessage("Error fetching report data.");
    } finally {
      setLoading(false);
    }
  };

  const downloadExcel = async () => {
    if (reportData.length === 0) return;

    const distName =
      selectedDistrict === "ALL"
        ? "AllDistricts"
        : districts.find((d) => d.distCode === selectedDistrict)?.distNameEn || selectedDistrict;

    const afsoName =
      selectedAfso === "ALL"
        ? "AllAFSOs"
        : afsos.find((a) => a.afsoCode === selectedAfso)?.afsoName || selectedAfso;

    const fileName = `NonAvailCards_${distName}_${afsoName}_${getMonthName(
      startMonth
    )}${startYear}_${getMonthName(endMonth)}${endYear}.xlsx`;

    const mainHeader = `Non Availed Cards Report`;
    const subHeader = `From ${getMonthName(startMonth)}, ${startYear} to ${getMonthName(
      endMonth
    )}, ${endYear} (${distName} - ${afsoName})`;

    const tableData = [
      ["District", "Block", "FPS ID", "RC ID", "Scheme", "Scheme Type", "Units"],
      ...reportData.map((item) => [
        item.district,
        item.block,
        item.fpsId,
        item.rcId,
        item.scheme,
        item.schemeType,
        item.units,
      ]),
      [
        "",
        "",
        "",
        "",
        "",
        "",
        reportData.reduce((sum, r) => sum + (r.units || 0), 0),
      ],
    ];

    await exportStyledExcel(tableData, fileName, mainHeader, subHeader);
  };

  return (
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "10px",
        }}
      >
        <table>
          <tbody>
            <tr>
              <td style={{ padding: "2px" }}>
                <label htmlFor="district" style={{ fontWeight: "bold", fontSize: "15px", marginRight: "8px" }}>
                  District:
                </label>
                <select
                  id="district"
                  value={selectedDistrict}
                  onChange={(e) => setSelectedDistrict(e.target.value)}
                  style={{ width: "160px", padding: "4px", borderRadius: "4px", border: "1px solid #aaa" }}
                >
                  <option value="">-- Select District --</option>
                  <option value="ALL">All Districts</option>
                  {districts.map((dist) => (
                    <option key={dist.distCode} value={dist.distCode}>
                      {dist.distNameEn} ({dist.distCode})
                    </option>
                  ))}
                </select>
              </td>

              <td style={{ padding: "5px" }}>
                <label htmlFor="afso" style={{ fontWeight: "bold", fontSize: "15px", marginRight: "8px" }}>
                  AFSO:
                </label>
                <select
  id="afso"
  value={selectedAfso}
  onChange={(e) => setSelectedAfso(e.target.value)}
  disabled={!selectedDistrict || loadingAfso}
  style={{
    width: "160px",
    padding: "4px",
    borderRadius: "4px",
    border: "1px solid #aaa",
    backgroundColor: loadingAfso ? "#f3f3f3" : "white",
  }}
>
  <option value="">-- Select AFSO --</option> 
  {afsos.length > 0
    ? afsos.map((a) => (
        <option key={a.afsoCode} value={a.afsoCode}>
          {a.afsoName} ({a.afsoCode})
        </option>
      ))
    : <option value="">No AFSOs Found</option>}
</select>

              </td>

              <td style={{ padding: "5px" }}>
                <button
                  onClick={handleGetLink}
                  style={{
                    backgroundColor: "#030303",
                    color: "white",
                    border: "none",
                    padding: "6px 10px",
                    borderRadius: "20px",
                    fontSize: "12px",
                    cursor: "pointer",
                  }}
                >
                  Get Link
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {loading ? (
        <div style={{ marginTop: "20px", textAlign: "center" }}>
          <img src={progressGif} alt="Loading..." width="220" height="12" />
        </div>
      ) : message ? (
        message === "No data found for the selected filters." ? (
          <div
            style={{
              color: "darkred",
              fontWeight: "bold",
              textAlign: "center",
              margin: "20px 0",
              fontSize: "20px",
            }}
          >
            No Data Found
          </div>
        ) : (
        <div
    style={{
      display: "flex",
      justifyContent: "center",
      marginTop: "20px",
      width: "100%",      
    }}
  >
    <p
      style={{
        color: "blue",
        cursor: "pointer",
        fontSize: "16px",
        fontWeight: "bold",
        whiteSpace: "nowrap",    
        margin: 0,
      }}
      onClick={downloadExcel}
      onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
      onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
    >
      {message}
    </p>
  </div>

        )
      ) : null}
    </div>
  );
};

function getMonthName(num) {
  const names = [
    "",
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return names[num] || "";
}

export default Non_Avail_Cards_Excel;
